var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('groupish',{attrs:{"with-users":false,"type":"group"},on:{"input":_vm.createGroup}})}
var staticRenderFns = []

export { render, staticRenderFns }